var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 3.11111L10.0625 0H1.64062C1.21779 0 0.875 0.348227 0.875 0.777778V13.2222C0.875 13.6518 1.21779 14 1.64062 14H12.3594C12.7822 14 13.125 13.6518 13.125 13.2222V3.11111ZM12.3594 13.2222H1.64062V0.777778H7V2.72222C7 4.375 7.875 6.5625 10.4453 6.5625H12.3594V13.2222ZM12.3594 4.8125V3.609L9.70334 0.777778H8.18065L8.24928 2.87782C8.28452 3.95639 9.16907 4.8125 10.2482 4.8125H12.3594Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatIcon);
export default __webpack_public_path__ + "static/media/format-icon.8f3930eacc93a6f180a0e5f5f6ab9c17.svg";
export { ForwardRef as ReactComponent };